import { PUBLISHER_TOKEN } from '@/constants/params';
import { isMobileDevice } from './device';
import type { CheckoutTheme } from '@/types/boot';
import { isTemplateSupportBG } from './template';
import type { Templates } from '@/types/common';

export const getPublisherToken = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const publisherToken = searchParams.get(PUBLISHER_TOKEN) || '';
  return publisherToken;
};

export const hasPublisherHaveBackgroundImage = (checkoutTheme: CheckoutTheme, templateType: Templates) => {
  const backgroundImage = isMobileDevice()
    ? checkoutTheme?.mobileBgImage || checkoutTheme?.backgroundImage
    : checkoutTheme?.backgroundImage;

  return Boolean(backgroundImage) && isTemplateSupportBG(templateType);
};
